import { IconAlertCircle } from '@iwoca/icons';
import { Button } from '@iwoca/orion';

import { useGetPayLinkByPayLinkId } from '../../../../../api/lending/lapiHooks';
import { LoadingSpinner } from '../../../../../components/LoadingSpinner/LoadingSpinner';
import { iwocaTelDisplay } from '../../../../../constants.json';
import { useQueryParam } from '../../../../../hooks/useQueryParam';
import { displayCurrency } from '../../../../../utils/DisplayCurrency';
import { WhiteLabelOverride } from '../../../../components/WhiteLabelOverride/WhiteLabelOverride';

export const SoleTraderOption = ({
  loading = false,
}: {
  loading?: boolean;
}) => {
  const payLinkId = useQueryParam('payLinkId');
  const { payLink, loadingPayLink } = useGetPayLinkByPayLinkId({
    payLinkId: payLinkId!,
  });

  const requestedAmountText =
    'Pay ' + displayCurrency(payLink?.amount || 0) + ' via bank transfer';

  const redirectToPayLinkLanding = () => {
    window.location.href = `/pay/to/${payLink?.seller_handle}/${payLinkId}/`;
  };

  return (
    <div>
      <div className="mb-l grid grid-cols-[min-content_1fr] gap-m overflow-hidden rounded-m bg-secondary-95 p-l">
        <IconAlertCircle className="mt-xs h-[25px] w-[25px] fill-secondary-20" />
        <div className="text-m text-secondary-20">
          <p className="mb-xs mt-0">
            If you’re a Sole Trader you can only use Pay Now.
          </p>
          <p className="my-0">
            We’re working to make Pay Later open to Sole Traders.
          </p>
        </div>
      </div>
      {payLinkId &&
        (requestedAmountText ? (
          <WhiteLabelOverride componentType="button" disabled={loading}>
            <Button
              type="button"
              loading={loading}
              onClick={redirectToPayLinkLanding}
            >
              {loadingPayLink ? <LoadingSpinner /> : <>{requestedAmountText}</>}
            </Button>
          </WhiteLabelOverride>
        ) : (
          <p className="text-error">
            We were unable to establish your application, please try to refresh
            the page or call us on {iwocaTelDisplay}
          </p>
        ))}
    </div>
  );
};
